import entersViewport from "./entersViewport";

(function () {
    const progressCircles = document.querySelectorAll(".missionProject__progressCirclePrimary");


    for (const progressCircle of progressCircles) {
        const progress = progressCircle.getAttribute("data-progress");
        if (entersViewport(progressCircle)) {
            setTimeout(() => {
                progressCircle.style.strokeDashoffset =
                  721 - (721 * progress) / 100;
            }, 1000)
          
        }


        const showProgress = () => {
            if (entersViewport(progressCircle, 100)) {
                progressCircle.style.strokeDashoffset = 721 - (721 * progress) / 100;
            }
        }

        document.addEventListener('scroll', showProgress, { passive: true });
    }

})()